import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "quantity-edit-container" }
const _hoisted_2 = { class: "quantity-display" }
const _hoisted_3 = { class: "quantity-controls" }
const _hoisted_4 = { class: "action-buttons" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _ctx.visible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.visible) = $event)),
    direction: "btt",
    size: "225px",
    "before-close": _ctx.handleBeforeClose,
    "with-header": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              class: "quantity-btn minus-btn",
              onClick: _ctx.decreaseQuantity,
              disabled: _ctx.currentQuantity <= 0,
              size: "large",
              circle: ""
            }, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createElementVNode("span", { class: "btn-text" }, "−", -1)
              ])),
              _: 1
            }, 8, ["onClick", "disabled"]),
            _createVNode(_component_el_input, {
              modelValue: _ctx.currentQuantity,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentQuantity) = $event)),
              modelModifiers: { number: true },
              class: "quantity-input",
              type: "number",
              inputmode: "numeric",
              pattern: "[0-9]*",
              min: 0,
              max: 99999,
              onInput: _ctx.handleInput,
              onBlur: _ctx.validateInput,
              onFocus: _ctx.handleFocus
            }, null, 8, ["modelValue", "onInput", "onBlur", "onFocus"]),
            _createVNode(_component_el_button, {
              class: "quantity-btn plus-btn",
              onClick: _ctx.increaseQuantity,
              disabled: _ctx.currentQuantity >= 99999,
              size: "large",
              circle: ""
            }, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createElementVNode("span", { class: "btn-text" }, "+", -1)
              ])),
              _: 1
            }, 8, ["onClick", "disabled"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_el_button, {
            onClick: _ctx.handleCancel,
            class: "cancel-btn"
          }, {
            default: _withCtx(() => _cache[4] || (_cache[4] = [
              _createTextVNode(" キャンセル ")
            ])),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _ctx.handleConfirm,
            class: "confirm-btn"
          }, {
            default: _withCtx(() => _cache[5] || (_cache[5] = [
              _createTextVNode(" 更新 ")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "before-close"]))
}